import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Alertstripe from "nav-frontend-alertstriper";
import { Hamburgerknapp, Menyknapp, Systemerknapp, Nesteknapp, Tilbakeknapp, Xknapp, Søkeknapp } from "nav-frontend-ikonknapper";
export const _frontmatter = {
  "ingress": "Denne pakken inneholder en samling med ferdig-komponerte knapper med tilhørende ikon."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#tilbake-nesteknapp"
          }}>{`Tilbake-/Nesteknapp`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#søkeknapp"
          }}>{`Søkeknapp`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#menyknapp"
          }}>{`Menyknapp`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#hamburgerknapp"
          }}>{`Hamburgerknapp`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#systemerknapp"
          }}>{`Systemerknapp`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#xknapp"
          }}>{`Xknapp`}</a></li></ol></nav>
    <h2 {...{
      "id": "tilbake-nesteknapp"
    }}>{`Tilbake-/Nesteknapp`}</h2>
    <Example mdxType="Example">
  <Tilbakeknapp mdxType="Tilbakeknapp" />
  &nbsp;
  <Nesteknapp mdxType="Nesteknapp" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Tilbakeknapp, Nesteknapp } from 'nav-frontend-ikonknapper';

<Tilbakeknapp />
<Nesteknapp />
`}</code></pre>
    <h2 {...{
      "id": "søkeknapp"
    }}>{`Søkeknapp`}</h2>
    <Example mdxType="Example">
  <Søkeknapp mdxType="S\xF8keknapp" />
  &nbsp;
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Søkeknapp } from "nav-frontend-ikonknapper";

<Søkeknapp />;
`}</code></pre>
    <Example mdxType="Example">
  <Søkeknapp mdxType="S\xF8keknapp">
    <span>Valgfri tekst</span>
  </Søkeknapp>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Søkeknapp } from "nav-frontend-ikonknapper";

<Søkeknapp>
  <span>Valgfri tekst</span>
</Søkeknapp>;
`}</code></pre>
    <h2 {...{
      "id": "menyknapp"
    }}>{`Menyknapp`}</h2>
    <Example mdxType="Example">
  <Menyknapp mdxType="Menyknapp" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Menyknapp } from "nav-frontend-ikonknapper";

<Menyknapp />;
`}</code></pre>
    <Example mdxType="Example">
  <Menyknapp mdxType="Menyknapp">
    <span>Valgfri tekst</span>
  </Menyknapp>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Menyknapp } from "nav-frontend-ikonknapper";

<Menyknapp>
  <span>Valgfri tekst</span>
</Menyknapp>;
`}</code></pre>
    <h2 {...{
      "id": "hamburgerknapp"
    }}>{`Hamburgerknapp`}</h2>
    <Example mdxType="Example">
  <Hamburgerknapp mdxType="Hamburgerknapp" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Hamburgerknapp } from "nav-frontend-ikonknapper";

<Hamburgerknapp />;
`}</code></pre>
    <h2 {...{
      "id": "systemerknapp"
    }}>{`Systemerknapp`}</h2>
    <Example mdxType="Example">
  <Systemerknapp mdxType="Systemerknapp" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Systemerknapp } from "nav-frontend-ikonknapper";

<Systemerknapp />;
`}</code></pre>
    <h2 {...{
      "id": "xknapp"
    }}>{`Xknapp`}</h2>
    <Example mdxType="Example">
  <Xknapp mdxType="Xknapp" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Xknapp } from "nav-frontend-ikonknapper";

<Xknapp />;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      